import Vue from 'vue'
/**权限指令**/
const has = Vue.directive('has', {
 inserted(el, binding, vnode){
     let row = binding.value;
     let code = binding.arg;
    if (!Vue.prototype.$_has(code,row)) {
        el.style.display = 'none';
        // Vue.nextTick(()=>{
        //     //el.parentNode.removeChild(el);
        // });
    }else{
        el.style.display = '';
    }
 },
 componentUpdated(el, binding, vnode,oldVnode){
    let row = binding.value;
    let code = binding.arg;
   if (!Vue.prototype.$_has(code,row)) {
        el.style.display = 'none';
    }else{
        el.style.display = '';
    }
}
});
// 权限检查方法
Vue.prototype.$_has = function (code,row) {
 let isExist = false;
 let permissions = row.data.permissions;
 if (permissions == undefined || permissions == null) {
  return false;
 }
 if (permissions.includes(code)) {
  isExist = true;
 }
 return isExist;
};


// 权限检查方法
// 如果页面中使用循环数据为result，则将row.result传入，返回数据格式为[{"data":{"":""},"pageOpers":[]}]
Vue.prototype.$renderRowResult = function (result) {
    // let data = [];
    let resData = [];
    if(result && result.length>0){
        // 适应咱们工程，数据改造成现使用数据结构
        for(let i = 0; i < result.length; i++) {
            let {data,pageOpers} = result[i];
            if(pageOpers){
                data.permissions = pageOpers.map(value=>value.code);
            }
        }
        return result;
        // 从市政采拿过来的处理数据逻辑，处理之后数据格式不适用用现工程
        /* data = result.map(item=>{
            let {data,pageOpers} = item;
            if(pageOpers){
                data.permissions = pageOpers.map(value=>value.code);
            }
            return data;
        }); */
    }
    return resData;
};

// 如果页面中红使用的数据为data.
Vue.prototype.$renderRowData = function (result) {
    let data = [];
    if(result && result.length>0){
        data = result.map(item=>{
            let {data,pageOpers} = item;
            if(pageOpers){
                data.permissions = pageOpers.map(value=>value.code);
            }
            return data;
        });
    }
    return data;
};

// 权限检查方法
Vue.prototype.$_hasData = function (code,row) {
    let isExist = false;
    let permissions = row.permissions;
    if (permissions == undefined || permissions == null) {
     return false;
    }
    if (permissions.includes(code)) {
     isExist = true;
    }
    return isExist;
   };
export {has}
export {hasData}



// WEBPACK FOOTER //
// ./src/directive/rowPermissions.js